import React from 'react'
import styled from 'styled-components'

import BasicFooter from '~/components/dashboard/Layout/Footer/BasicFooter'
import FeaturedIn from '~/components/dashboard/Layout/Footer/logos/FeaturedInLogo'
import CopBackground from '../../public/static/images/webp/copBackground.webp'

const CopImageContainer = styled.div`
  height: 435px;
  width: 100%;
  background: url(${CopBackground}) no-repeat center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
`

const FeaturedInContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 64%;
  ${props => props.theme.media.mobile`
    width: 90%;
  `}
`

const Footer = ({ noMedia = false, isStateAffiliatedWithWinitLaw }) => {
  return (
    <BasicFooter isStateAffiliatedWithWinitLaw={isStateAffiliatedWithWinitLaw}>
      {noMedia ? null : (
        <>
          <CopImageContainer>
            <FeaturedInContainer>
              <FeaturedIn />
            </FeaturedInContainer>
          </CopImageContainer>
        </>
      )}
    </BasicFooter>
  )
}

export default Footer
